import { getSafeValue } from "./common";
export function getMinutosPorGol(player) {
  const goles =
    getSafeValue(player, "goles.golesTotales") +
    getSafeValue(player, "goles.golesTotalesPenalti");

  // Aquí sumamos los minutos de local y visitante, igual que en la columna de minutosJugados
  const minutos =
    getSafeValue(player, "minutos.minutosJugadosLocal") +
    getSafeValue(player, "minutos.minutosJugadosVisitante");

  if (goles > 0 && minutos > 0) {
    const minutosPorGol = minutos / goles;
    return Number(minutosPorGol.toFixed(0)); // Mostrar el valor calculado con 2 decimales
  }

  return Number(0); // Si no tiene goles o minutos, mostramos "N/A"
}

export function getGolesPorPartido(player) {
  const goles =
    getSafeValue(player, "goles.golesTotales") +
    getSafeValue(player, "goles.golesTotalesPenalti");
  const partidosJugados =
    getSafeValue(player, "partidos.partidosJugadosLocal") +
    getSafeValue(player, "partidos.partidosJugadosVisitante");

  if (partidosJugados > 0) {
    const golesPorPartido = goles / partidosJugados;
    return Number(golesPorPartido.toFixed(2)); // Redondear a 2 decimales
  }

  return 0; // Si no hay partidos jugados, se devuelve 0
}

export function getJugadoresDestados(goleadores, masMinutos) {
  const maxTotal = 6;
  const maxPorArray = 3;

  // 1️⃣ Cuántos coge del primero (máx 3)
  const cantidadGoleadores = Math.min(goleadores.length, maxPorArray);

  // 2️⃣ Cuántos necesita del segundo para completar hasta 6
  const cantidadMinutos = Math.min(
    masMinutos.length,
    maxTotal - cantidadGoleadores
  );

  // 3️⃣ Tomar los seleccionados
  let seleccionados = [
    ...goleadores.slice(0, cantidadGoleadores),
    ...masMinutos.slice(0, cantidadMinutos),
  ];

  // 4️⃣ Eliminar duplicados (por idJugador)
  seleccionados = seleccionados.filter(
    (item, index, self) =>
      index === self.findIndex((j) => j.idJugador === item.idJugador)
  );

  // 5️⃣ Si faltan elementos, rellenar desde el segundo array
  let i = 0;
  while (seleccionados.length < maxTotal && i < masMinutos.length) {
    const candidato = masMinutos[i];
    if (!seleccionados.some((j) => j.idJugador === candidato.idJugador)) {
      seleccionados.push(candidato);
    }
    i++;
  }

  // 6️⃣ Si aún faltan, intentar completar desde goleadores
  let j = 0;
  while (seleccionados.length < maxTotal && j < goleadores.length) {
    const candidato = goleadores[j];
    if (!seleccionados.some((p) => p.idJugador === candidato.idJugador)) {
      seleccionados.push(candidato);
    }
    j++;
  }

  return seleccionados;
}
